import React from 'react'
import { RealEstateFeatures } from '../../../../../@types/types'
import { estateFeatures } from '../../../../../components/pages/insertionPage/screens/otherFacilities/wrapper/otherFacilitiesFieldsWrapper'
import { BuildingTypeOption } from '../../../../../@types/dropdown-types'

// Estate features for house sell flows (based on desktop propertyOwnerHouseSellFlow)
export const houseSellEstateFeaturesList = [
  RealEstateFeatures.STEPLESS_ACCESSIBLE,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.SUMMER_RESIDENCE_PRACTICAL,
  RealEstateFeatures.BASEMENT,
  RealEstateFeatures.LODGER_FLAT,
  RealEstateFeatures.MONUMENT,
]

export const createHouseSellEstateFeaturesForWebView = (label: React.ReactNode, className: string) =>
  estateFeatures(houseSellEstateFeaturesList, label, className)

export const houseSellBuildingTypeOptions = [
  BuildingTypeOption.SINGLE_FAMILY_HOUSE,
  BuildingTypeOption.MID_TERRACE_HOUSE,
  BuildingTypeOption.END_TERRACE_HOUSE,
  BuildingTypeOption.MULTI_FAMILY_HOUSE,
  BuildingTypeOption.BUNGALOW,
  BuildingTypeOption.FARMHOUSE,
  BuildingTypeOption.SEMIDETACHED_HOUSE,
  BuildingTypeOption.VILLA,
  BuildingTypeOption.CASTLE_MANOR_HOUSE,
  BuildingTypeOption.SPECIAL_REAL_ESTATE,
  BuildingTypeOption.OTHER,
]
